import React from "react";
import "./App.css"
import plot from "./plot.svg"

class Predictor extends React.Component {
    constructor(props) {
      super(props);
      this.state = { items: [], text: '' };
      this.handleChange = this.handleChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
    }
  
    render() {
      return (
        <div id="mainsection" className="mainsection">
            <h3 className="mainHeader">CRIME COUNT PREDICTOR</h3>
            <div className="mainsub">
                <form onSubmit={this.handleSubmit} className="FormInput">
                    <input className="FormBar"
                        onChange={this.handleChange}
                        value={this.state.text}
                        placeholder="Enter a year.."
                    />
                    <button className="FormBtn" >
                        ADD
                    </button>
                </form>
                <GetValue items={this.state.items} />
            </div>
        </div>
      );
    }
  
    handleChange(e) {
      this.setState({ text: e.target.value });
    }
  
    handleSubmit(e) {
      e.preventDefault();
      if (!this.state.text.length) {
        return;
      }
      const newItem = {
        text: this.state.text,
        id: Date.now()
      };
      this.setState(state => ({
        items: state.items.concat(newItem),
        text: ''
      }));
    }
  }
  
  class GetValue extends React.Component {
    render() {
      return (
    <table className="FormTable">
    <thead>
        <tr>
            <th > Year</th>
            <th > Prediction</th>
        </tr>
    </thead>
    <tbody>
    {this.props.items.map(item => (
        <tr key={item.id}>
            <th> {item.text} </th>
            <td> {parseInt(16900443.58-8323.53*item.text)} </td>
        </tr>
    ))}
    </tbody>
</table>
      );
    }
  }
  
  export default Predictor;